const widgetsSectionStyles = {
  section: {
    padding: 24,
  },
  sectionTitle: {
    marginBottom: 8,
    fontWeight: 500,
  },
  sectionSubtitle: {
    marginBottom: 24,
    color: 'rgba(0, 0, 0, 0.6)',
  },
  docsLink: {
    color: '#E0726E',
    textDecoration: 'underline',
  },
  requireStatsMessage: {
    padding: 16,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: 4,
    color: 'rgba(0, 0, 0, 0.7)',
    fontStyle: 'italic',
  },
  snippetWrapper: {
    marginBottom: 24,
  },
  widgetTitle: {
    marginBottom: 8,
    fontWeight: 500,
  },
  controls: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 12,
  },
  codeBlockWrapper: {
    position: 'relative',
  },
  codeBlock: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    padding: 16,
    paddingRight: 48,
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace',
    fontSize: 13,
    lineHeight: 1.5,
    overflowX: 'auto',
    margin: 0,
    whiteSpace: 'pre',
  },
  copyButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
}

export default widgetsSectionStyles
